module.exports = "<!DOCTYPE html>\n<html>\n\n<head>\n  <meta charset=\"utf-8\">\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n  <title>{{files.0.name}}</title>\n  <link rel=\"stylesheet\" href=\"https://stackedit.cn/style.css\" />\n</head>\n\n{{#if pdf}}\n<body class=\"stackedit stackedit--pdf\">\n{{else}}\n<body class=\"stackedit\">\n{{/if}}\n  <div class=\"stackedit__html\">{{{files.0.content.html}}}</div>\n</body>\n\n</html>\n"


//////////////////
// WEBPACK FOOTER
// ./src/data/templates/styledHtmlTemplate.html
// module id = 2280
// module chunks = 1